import SearchIcon from '@mui/icons-material/Search';
import { FormHelperText, Stack } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { SearchIconWrapper } from './../SearchIconWrapper';
import { StyledInputBase } from './../StyledInputBase';

export interface SearchBarInputProps {
  name: string;
  placeholder: string;
  IconPosition?: 'left' | 'right';
  eventTriggered?: () => void;
}

export default function SearchBar({
  name,
  placeholder,
  IconPosition = 'left',
}: SearchBarInputProps) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <>
          <Stack direction="row">
            {IconPosition == 'left' && (
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
            )}
            <StyledInputBase
              id="search-input"
              placeholder={placeholder}
              onChange={onChange}
              value={value}
              fullWidth
            />
            {IconPosition == 'right' && (
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
            )}
          </Stack>
          {error && <FormHelperText error>{error.message}</FormHelperText>}
        </>
      )}
    />
  );
}
